<script lang="ts">
  import { Col} from "sveltestrap";
  import {cart} from "../../../../store"
  import { Product, Total } from "../../../../utils/Constant/Constant";
  import PaymentMethod from "./PaymentMethod.svelte";
  import ProductTotalSub from "./ProductTotalSub.svelte";
  let setCart:any
  cart.subscribe((value)=>{
    setCart = value
  })
</script>
<Col xl="6" sm="12">
  <div class="checkout-details">
    <div class="order-box">
      <div class="title-box">
        <div class="checkbox-title">
          <h4 class="mb-0">{Product} </h4>
          <span>{Total}</span>
        </div>
      </div>
      {#each setCart as selectItem}
        {#if selectItem.name !== undefined}
          <ul class="qty">
            <li>{selectItem.name} × {selectItem.qty} <span>$ {selectItem.price * selectItem.qty}</span></li>
          </ul>
        {/if}
      {/each}
      <ProductTotalSub />
      <PaymentMethod />
    </div>
  </div>
</Col>